import { render, staticRenderFns } from "./ReportRawData.vue?vue&type=template&id=81f7363a&scoped=true&"
import script from "./ReportRawData.vue?vue&type=script&lang=js&"
export * from "./ReportRawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f7363a",
  null
  
)

export default component.exports